import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { PmtAgGridModule } from '@premotec/pmt-ag-grid';
import { ErrorComponent, PmtBootstrapModule } from '@premotec/pmt-bootstrap';
import { PmtDatepickerModule } from '@premotec/pmt-datepicker';
import { PmtEssentialsModule } from '@premotec/pmt-essentials';
import { AgGridModule } from 'ag-grid-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgPipesModule } from 'ngx-pipes';
import { ToastrModule } from 'ngx-toastr';
import Quill from 'quill';

import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { MultiLineCellRendererComponent } from './components/multi-line-cell-renderer/multi-line-cell-renderer.component';
import { CustomQuillLink } from './quill/custom-quill-link';
import { CopyToClipboardCellRendererComponent } from './components/copy-to-clipboard-cell-renderer/copy-to-clipboard-cell-renderer.component';

// Register custom quill link 
Quill.register('formats/link', CustomQuillLink, true);

const defaultModules = [CommonModule, FormsModule, ReactiveFormsModule];

const customModules = [
    ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        timeOut: 3000, // Auto-close in 3s,
        autoDismiss: true,
        closeButton: true,
        countDuplicates: true,
        preventDuplicates: true,
    }),
    NgSelectModule,
    TranslocoModule,
    AgGridModule,
    NgPipesModule,
];

const pmtModules = [
    PmtDatepickerModule,
    PmtEssentialsModule,
    PmtBootstrapModule.forRoot({
        pmtActionModalConfig: {
            modalHeaderClass: 'bg-white',
            modalFooterClass: 'bg-white',
            modalBodyClass: 'bg-white',
            modalTitleClass: 'h4',
            buttonCancelClass: 'btn btn-light',
            buttonSubmitClass: 'btn btn-primary'
        }
    }),
    PmtAgGridModule,
];

@NgModule({
    imports: [
        defaultModules,
        customModules,
        pmtModules,
        RouterModule,
        TimepickerModule
    ],
    declarations: [
        LoadingIndicatorComponent,
        MultiLineCellRendererComponent,
        CopyToClipboardCellRendererComponent
    ],
    exports: [
        defaultModules,
        customModules,
        pmtModules,
        ReactiveFormsModule,
        TooltipModule,
        TabsModule,
        BsDropdownModule,
        TimepickerModule,
        LoadingIndicatorComponent,
        MultiLineCellRendererComponent,
        ErrorComponent,
        CopyToClipboardCellRendererComponent
    ],
    providers: [DatePipe, BsModalService],
})
export class SharedModule { }
